/**
 * Appointment Types Data Model
 * 
 * Defines field names for the appointment types resource.
 * Maps frontend field names to backend API response fields.
 */

export const appointmentTypesFields = {
    id: "id",
    name: "name",
    clientDisplayName: "client_display_name",
    length: "length",
    availableContactTypes: "available_contact_types",
    isGroup: "is_group",
    clientsCanBook: "clients_can_book",
    pricing: "pricing",
    pricingOption: "pricing_option",
    position: "position",
    insuranceBillingEnabled: "insurance_billing_enabled",
    requireSpecificProviders: "require_specific_providers",
    requireInStateClients: "require_in_state_clients",
    requireCcAtBooking: "require_cc_at_booking",
    dontAskForReason: "dont_ask_for_reason",
    isWaitlistEnabled: "is_waitlist_enabled",
    bookableByGroups: "bookable_by_groups",
    bookableWithoutGroup: "bookable_without_group",
    customTextReminderBody: "custom_text_reminder_body",
    metadata: "metadata",
    createdAt: "created_at",
    updatedAt: "updated_at",
    deletedAt: "deleted_at",
};

export const APPOINTMENT_TYPES_RESOURCE_NAME = "healthie-appointment-types";

